import { DependencyList, useCallback, useState } from "react"

export function useCallbackWithLoading<
  T extends (...args: K[]) => Promise<R>,
  K = any,
  R = any,
>(callback: T, deps: DependencyList, initialLoading?: boolean) {
  const [loading, setLoading] = useState(initialLoading ?? false)
  const cacheCallback = useCallback(async (...args) => {
    try {
      setLoading(true)
      return await callback(...args)
    } catch (error) {
      console.error(error)
      return null
    } finally {
      setLoading(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps)
  return [loading, cacheCallback] as [boolean, T]
}
